const newsletter = () => {
    const newsletterConsent = document.querySelector('.consents-first a')

    if (newsletterConsent) {
        newsletterConsent.href = '/vse-o-nakupu/ochrana-osobnich-udaju/'
    }
}

$(document).ready(function () {
    const footer = document.querySelector('footer#footer')

    if (footer) {
        newsletter();
    }
})

if($('footer#footer').length){
    $('body').append($('footer#footer .customSlideBanner'))
} 
